import type { WarehouseDataset } from "../types";

export function createEmptyDataset(warehouse = "昆山大仓"): WarehouseDataset {
  const today = new Date().toISOString().slice(0, 10);
  return {
    meta: {
      name: "等待业务数据",
      importedAt: new Date().toISOString(),
      source: "empty",
      asOf: today,
      warehouse,
    },
    sales: [],
    batches: [],
  };
}
